<script setup lang="ts">
import { MMLink, MMImage, MMText, MMIcon, type EMMIconName } from "@mm-frontend/mm-web-ui-kit";
import type { ESearchSuggestionItemType } from "../models/TSuggestionItem";
import { useAppSearch } from "../business/useAppSearch";

const props = defineProps<{
  type: ESearchSuggestionItemType;
  title: string;
  subtitle?: string;
  image?: string;
  icon?: EMMIconName;
  url: string;
}>();

const emit = defineEmits(['click']);

const { closeSearchResults } = useAppSearch();

function handleClick() {
  emit('click');
  closeSearchResults();
}
</script>

<template>
  <MMLink 
    :to="url" 
    :class="`suggestion-item--${type}`"
    class="suggestion-item" 
    @click="handleClick"
  >
    <img v-if="image" :src="image" class="suggestion-item__image">
    <MMIcon v-if="icon" :name="icon" class="suggestion-item__icon" color="disabled" :height="20" :width="20" />

    <div class="suggestion-item__content">
      <MMText font="Body M/Regular" :label="title" />
      <MMText font="Body S/Regular" color="secondary" :label="subtitle" />
    </div>
  </MMLink>
</template>

<style scoped lang="stylus">
.suggestion-item
  display flex
  align-items flex-start
  gap 12px
  padding 14px 16px
  width 100%
  box-sizing border-box
  transition background-color var(--default-transition-duration) var(--default-transition-timing-function)
  align-items center

  &:hover
    +Media(Laptop, Desktop, DesktopMax)
      background-color var(--surface-primary-hovered)

  &__image
    width 40px
    height 40px
    object-fit cover
    border-radius 8px

  &__content
    display flex
    flex-direction column
    align-items flex-start
    gap 0
</style>